module.exports = __webpack_public_path__ + "static/hero-a5a511f43b31ebd51032cd904d6afb4c.jpg";